import comp from "./SnpVisitorSignup";
export default comp;
